import { useCallback } from "react";
import { DialogName } from "../../../constants/dialogRegistery";
import { useAppDispatch, useAppSelector } from "../redux/redux.hook";
import { appendDialog, destroy, destroyAll } from "./dialog.slice";

interface DialogCallbacks {
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void;
}

const dialogCallbacks = new Map<string, DialogCallbacks>();

const useDialog = () => {
  const dispatch = useAppDispatch();
  const { dialogs } = useAppSelector((state) => state.dialog);

  const createDialog = useCallback(
    (name: DialogName, callbacks?: DialogCallbacks) => {
      const dialogId = `${name}-${Date.now()}-${Math.random()}`;

      if (callbacks) {
        dialogCallbacks.set(dialogId, callbacks);
      }

      dispatch(
        appendDialog({
          name,
          dialogId,
        }),
      );
    },
    [dispatch],
  );

  const destroyDialog = useCallback(
    (dialogId?: string) => {
      if (dialogId) {
        dialogCallbacks.delete(dialogId);
      }
      dispatch(destroy());
    },
    [dispatch],
  );

  const destroyAllDialogs = useCallback(() => {
    dialogCallbacks.clear();
    dispatch(destroyAll());
  }, [dispatch]);

  const getCallbacks = useCallback((dialogId: string) => {
    return dialogCallbacks.get(dialogId);
  }, []);

  return {
    dialogs,
    createDialog,
    destroyDialog,
    destroyAllDialogs,
    getCallbacks,
  };
};

export default useDialog;
